
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/m/cabrini-exclusive-scene/gift",
      function () {
        return require("private-next-pages/[locale]/m/cabrini-exclusive-scene/gift/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/m/cabrini-exclusive-scene/gift"])
      });
    }
  